import { render, staticRenderFns } from "./ReviewModifyVinculation.vue?vue&type=template&id=b1d18d26&scoped=true"
import script from "./ReviewModifyVinculation.vue?vue&type=script&lang=js"
export * from "./ReviewModifyVinculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d18d26",
  null
  
)

export default component.exports